import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const BannerContainer: LoadableType<{
	usePortalSpacer?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BannerContainer" */ './BannerContainer.tsx'))
			.BannerContainer,
});
